import styled from 'styled-components';
import { mq } from '../../../styles/sizes';
import { toRemStr } from '../../../utils/helpers';
import { SIDE_MENU_WIDTH_REM } from '../../../components/SideMenu/SideMenu.styled';

export const BannersWrapper = styled.div<{
  inPageWithSideMenu: boolean;
}>`
  ${({ inPageWithSideMenu }) =>
    inPageWithSideMenu && `margin-left: ${toRemStr(SIDE_MENU_WIDTH_REM)};`}
`;

export const BannerStyled = styled.div`
  display: flex;
  justify-content: space-between;
  gap: var(--s3);
  padding: var(--s3) var(--s4) var(--s3);
  background: var(--disabled);
  flex-wrap: wrap;
  &:not(:first-child) {
    border-top: 1px solid var(--white);
  }
`;

export const BannerDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--s2);
`;

export const BannerText = styled.p`
  font-size: var(--h4);
  margin: 0 0 0 0;
`;

export const BannerButtons = styled.div`
  width: 100%;
  margin-top: auto;
  display: flex;
  justify-content: center;
  gap: var(--s3);
  flex-wrap: wrap;
  button {
    width: 100%;
  }

  ${mq.xsm} {
    width: auto;
    justify-content: flex-end;

    button {
      width: auto;
    }
  }
`;
